import React, { useEffect, useState } from 'react'
import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ConfigProvider, Empty } from 'antd'
import store, { persistor } from './redux/index'
import { App } from './app'
import zhCN from 'antd/lib/locale/zh_CN'
import enUS from 'antd/lib/locale/en_US'
import dayjs from '@/utils/dayjs'
import i18n from './i18n'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { PersistGate } from 'redux-persist/integration/react'

// 抑制 Ant Design Table 组件的 defaultProps 警告
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' &&
      args[0].includes('Support for defaultProps will be removed from function components')
    ) {
      return
    }
    originalError.call(console, ...args)
  }
}

const Root: React.FC = () => {
  const [antdLocale, setAntdLocale] = useState(i18n.language.startsWith('en') ? enUS : zhCN)
  const LanguageSwitcherComp: React.ComponentType | null =
    process.env.NODE_ENV === 'development'
      ? // eslint-disable-next-line @typescript-eslint/no-var-requires
        (require('@/components/language-switcher').default as React.ComponentType)
      : null

  useEffect(() => {
    const handler = (lng: string) => {
      setAntdLocale(lng.startsWith('en') ? enUS : zhCN)
    }
    handler(i18n.language)
    i18n.on('languageChanged', handler)
    return () => {
      i18n.off('languageChanged', handler)
    }
  }, [])

  return (
    <Provider store={store}>
      <ConfigProvider
        locale={antdLocale}
        input={{
          autoComplete: 'off',
        }}
        getPopupContainer={(node: any) => (node?.parentNode ? node.parentNode : document.body)}
        renderEmpty={() => <Empty image={EmptyImg} />}
      >
        <BrowserRouter>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </BrowserRouter>
        {LanguageSwitcherComp ? <LanguageSwitcherComp /> : null}
      </ConfigProvider>
    </Provider>
  )
}

ReactDom.render(<Root />, document.getElementById('app'))
